import { useCallback } from 'react'

import type { TagProps } from '@interco/inter-toranja/dist/types/shared'
import useGlobalState from '@/contexts/global-state'
import { requestAnalyticsFromToranjaTag } from '@/utils/analytics/requestAnalyticsFromToranjaTag'

/**
 * screen_name vem de metadata.analytics do onboarding; o título do card é passado no onTag do Toranja.
 */
export function useHomeCreditListItemTag() {
  const [{ homeCreditOnboarding }] = useGlobalState()
  const screenName = homeCreditOnboarding?.screen?.metadata?.analytics?.screen_name ?? ''

  return useCallback(
    (tag: TagProps, cardTitle: string) => {
      if (!screenName) return
      requestAnalyticsFromToranjaTag(tag, screenName, cardTitle)
    },
    [screenName],
  )
}
